/*
 * File: KeyDealsDetail.tsx
 * Project: a-a
 * File Created: Wednesday, 8th January 2025 10:10:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 22nd August 2025 9:11:02 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
/*
 * File: KeyDealsCard.tsx
 * Project: a-a
 * File Created: Monday, 6th January 2025 7:52:47 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 8th January 2025 10:08:29 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';

import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomCard from '../../CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import CustomButton from '../../CustomButton/CustomButton';
import { Link, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import styles from './KeyDealsDetail.module.css';

function stripHtmlTags(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
}

type DealType = {
  accountId: string;
  name: string;
  accountName: string;
  stageName: string;
  amount: string | null;
  clientRevenue: string | null;
  companyRevenue: string | null;
  commitments: string | null;
  closeDate: string | null;
  lastModifiedByName: string | null;
  lastModifiedDate: string | null;
  createdByName: string | null;
  createdDate: string | null;
  ownerName: string | null;
  probability: number | null;
  type: string | null;
  opportunityType: string | null;
  termStart: string | null;
  termEnd: string | null;
  exclusivity: string | null;
  category: string | null;
  leadSource: string | null;
  reasonLost: string | null;
  partnerPercent: string | null;
  estimatedValuation: string | null;
  products: any;
  Name: string | null;
  Quantity: string | number | null;
  UnitPrice: string | number | null;
  dealId: string | null;
  commission: string | null;
  rate: string | null;
  dealSource: string | null;
  campaignName: string | null;
  gdEquity: boolean | null;
  Partner_Payout__c: string | null;
  exclusivityLanguage: string | null;
  compensation: string | null;
  services: string | null;
  productionStatus: string | null;
  arena: string | null;
  genre: string | null;
  options: string | null;
  conditions: string | null;
  executiveProducerServices: string | null;
  logLine: string | null;
  recoupability: string | null;
  executiveProducerFee: string | null;
  conditionsFees: string | null;
  magr: string | null;
  Guarantee__c: string | null;
  releaseType: string | null;
  rating: string | null;
  role: string | null;
  approxShootDateStart: string | null;
  approxShootDateEnd: string | null;
  episodicOrder: string | null;
};

const KeyDealsDetail = ({
  data,
  loading = false,
  setConfirmModal,
  handleDealCreateClick,
  setMessage,
}: {
  data: DealType | undefined;
  loading?: boolean;
  setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleDealCreateClick: (event: React.MouseEvent<HTMLDivElement>, onlyAnchor?: boolean) => void;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const theme = useTheme();
  // const params = useParams();
  const SFToken = sessionStorage.getItem('SFToken') === 'true';
  // const screenHeight = window.innerHeight;
  const [currentDetailsTab, setCurrentDetailsTab] = useState('deal');
  // const [copy, setCopy] = useState('');
  const handleCopyLink = (val: any) => {
    navigator.clipboard.writeText(val);
    setMessage('Copied Link');
  };

  return (
    <CustomCard
      styles={{
        // borderRadius: '14px',
        // height: '30rem',
        height: '100vh',
        paddingBottom: '28rem',
        // height: '100%',
        // paddingBottom: '3rem',
        // height:
        //   screenHeight > 1200
        //     ? '60vh'
        //     : screenHeight > 1100
        //     ? '56vh'
        //     : screenHeight > 1000
        //     ? '53vh'
        //     : screenHeight > 900
        //     ? '56vh'
        //     : screenHeight > 800
        //     ? '48vh'
        //     : screenHeight > 700
        //     ? '45vh'
        //     : screenHeight > 600
        //     ? '20vh'
        //     : '10vh', //screenHeight > 640 ? '44vh' : screenHeight > 500 ? '36vh' : '34vh', //'40vh',
        backgroundColor: zeplinColor.Neutral1,
        borderWidth: `1px 1px 1px 1px`,
        borderStyle: 'solid',
        borderColor: `${zeplinColor.Neutral5}`,
        borderRadius: '14px',
        overflowY: 'scroll',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          padding: { xs: '14px', xl: '24px' },
          display: 'flex',
          // flexDirection: 'column',
          gap: { xs: '6px', xl: '12px' },
          alignItems: 'center',
          // justifyContent: 'space-between'
          zIndex: '999',
          position: 'sticky',
          backgroundColor: zeplinColor.Neutral1,
          top: 0,
          height: { xs: '84px', xl: '104px' },
        }}
      >
        {loading ? (
          <Skeleton variant='rounded' width={32} height={32} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // flex: 1,
              padding: '10px',
              borderRadius: '8px',
              border: `1px solid ${zeplinColor.Neutral5}`,
              // width: '32px',
              // height: '32px',
            }}
          >
            <img
              src='/assets/no-keydeals.svg'
              className={styles['deal-logo']}
              style={{ objectFit: 'fill' }}
            />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: { xs: '6px', xl: '8px' },
            flex: 1,
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveDisplay5' style={{ textAlign: 'left' }}>
              {data?.name ?? 'N/A'}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              // justifyContent: 'space-between',
              alignItems: 'flex-end',
              gap: '8px',
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  flex: 1,
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Chip
                label={
                  <Typography
                    variant='responsiveLabel1'
                    color={zeplinColor.BasicBlack}
                    sx={{
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {data?.opportunityType ?? 'N/A'}
                  </Typography>
                }
                sx={{
                  backgroundColor: zeplinColor.Neutral4,
                  padding: '5px 12px 5px 12px',
                  borderRadius: '50px',
                  // width: '47px',
                  height: '24px',
                  '&.MuiChip-root': {
                    // flex: 1,
                  },
                  '& .MuiChip-label': {
                    padding: '0px',
                  },
                }}
              />
            )}
            {!loading && (
              <Link
                to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Opportunity/${data?.dealId}/view`}
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  color: zeplinColor.BasicBlack,
                  textDecoration: 'none',
                  cursor: 'pointer',
                }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '50px',
                    padding: '0px',
                    backgroundColor: zeplinColor.Neutral1,
                    border: `0px solid ${zeplinColor.Neutral6}`,
                    display: 'flex',
                    gap: '4px',
                    // flexDirection: 'column',
                    // alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: '0.1rem',
                    cursor: 'pointer',
                  }}
                >
                  <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                    Salesforce
                  </Typography>
                  <img src='/assets/link-blue.svg' className={styles['icon']} />
                </CustomCard>
              </Link>
            )}
          </Box>
        </Box>
        {/* <Box sx={{ display: 'flex', gap: '12px' }}>
          <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='outlined'
            color='secondary'
            style={{
              width: '100%',
              borderRadius: 14,
              height: 56,
              backgroundColor: zeplinColor.Brand1,

              gap: '16px',
              padding: '6px 12px',
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'Follow'}
          />
          <CustomButton
            disabled={false}
            onClick={() => {}}
            variant='outlined'
            color='secondary'
            style={{
              width: '100%',
              borderRadius: 14,
              height: 56,
              whiteSpace: 'nowrap',
              gap: '16px',
              padding: '6px 12px',
            }}
            textStyle={{ color: zeplinColor.BasicBlack, padding: '6px 12px' }}
            text={'Send to Slack'}
          />
        </Box> */}
        {/* <Link
          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/${data?.accountId}`}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '10px 10px 10px 16px',
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body3'>Salesforce</Typography>
            <img src='/assets/link-2.svg' width={20} height={20} />
          </CustomCard>
        </Link> */}

        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            alignItems: 'center',
            // justifyContent: 'space-between',
            // padding: '40px 24px 24px 24px',
          }}
        >
          <img
            src={'/assets/copy-view.png'}
            className={styles['action-icon']}
            alt='close'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleCopyLink(
                `https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Opportunity/${data?.dealId}/view`,
              );
            }}
          />
          {/* <img
                      src={'/assets/share.svg'}
                      width={'24px'}
                      height={'24px'}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      //   onClick={OnClickSubTask}
                    /> */}
          <img
            src={'/assets/edit-thin.svg'}
            className={styles['action-icon']}
            alt='close'
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              handleDealCreateClick(e);
              sessionStorage.setItem('selectedDeal', JSON.stringify(data));
              sessionStorage.setItem('activeDealTab', '0');
            }}
          />
          <img
            src={'/assets/delete.svg'}
            className={styles['action-icon']}
            alt='close'
            style={{ cursor: 'pointer' }}
            onClick={
              SFToken
                ? () => setConfirmModal(true)
                : (e) => {
                    handleDealCreateClick(e, true);
                    sessionStorage.setItem('deleteDeal', JSON.stringify(data));
                  }
            }
          />
          {/* <img
                      src={'/assets/vertical-dots.svg'}
                      width={'24px'}
                      height={'24px'}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      onClick={handleClick}
                    /> */}
        </Box>
      </Box>
      <Divider
        component='div'
        sx={{
          borderColor: zeplinColor.Neutral5,
          position: 'sticky',
          top: { xs: '84px', xl: '104px' },
        }}
      />
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          position: 'sticky',
          top: { xs: '84.5px', xl: '104.5px' },
          backgroundColor: zeplinColor.Neutral1,
          padding: { xs: '14px', xl: '24px' },
        }}
      >
        <Chip
          label={
            <Typography
              variant='responsiveLabel1'
              color={currentDetailsTab === 'deal' ? zeplinColor.Neutral1 : zeplinColor.BasicBlack}
              sx={{
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Deal Details
            </Typography>
          }
          sx={{
            zIndex: 0,
            backgroundColor:
              currentDetailsTab === 'deal' ? zeplinColor.BasicBlack : zeplinColor.Neutral4,
            '&:hover': {
              backgroundColor:
                currentDetailsTab === 'deal' ? zeplinColor.BasicBlack : zeplinColor.Neutral4,
            },
            padding: { xs: '10px', xl: '16px' },
            borderRadius: '50px',
            cursor: 'pointer',
            // width: '47px',
            height: { xs: '32px', xl: '40px' },
            '&.MuiChip-root': {
              // flex: 1,
            },
            '& .MuiChip-label': {
              padding: '0px',
            },
          }}
          onClick={() => setCurrentDetailsTab('deal')}
        />
        <Chip
          label={
            <Typography
              variant='responsiveLabel1'
              color={currentDetailsTab === 'price' ? zeplinColor.Neutral1 : zeplinColor.BasicBlack}
              sx={{
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Price Book & Products
            </Typography>
          }
          sx={{
            zIndex: 0,
            cursor: 'pointer',
            backgroundColor:
              currentDetailsTab === 'price' ? zeplinColor.BasicBlack : zeplinColor.Neutral4,
            padding: { xs: '10px', xl: '16px' },
            borderRadius: '50px',

            // width: '47px',
            height: { xs: '32px', xl: '40px' },

            // width: '47px',

            '&:hover': {
              backgroundColor:
                currentDetailsTab === 'price' ? zeplinColor.BasicBlack : zeplinColor.Neutral4,
            },
            '&.MuiChip-root': {
              // flex: 1,
            },
            '& .MuiChip-label': {
              padding: '0px',
            },
          }}
          onClick={() => setCurrentDetailsTab('price')}
        />
      </Box>
      {currentDetailsTab === 'deal' ? (
        <>
          <Box sx={{ padding: { xs: '0px 20px 20px 20px', xl: '0px 24px 24px 24px' } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}>
              <Typography variant='responsiveHeading3'>Opportunity Information</Typography>

              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/opportunity.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Opportunity name
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {data?.name ?? 'N/A'}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/account.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Account name
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Box sx={{ display: 'flex', gap: '4px', flex: 1, alignItems: 'center' }}>
                      <Box
                        sx={{
                          borderRadius: '100px',
                          padding: '10px',
                          width: '26px',
                          height: '26px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: zeplinColor.Brand1,
                        }}
                      >
                        <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                          {data?.accountName
                            ?.split(' ')
                            .map((value: any, index: number) =>
                              data?.accountName &&
                              (index === 0 || index === data?.accountName?.split(' ').length - 1)
                                ? value[0]
                                : '',
                            )}
                        </Typography>
                      </Box>
                      <Typography variant='responsiveBody2'>
                        {data?.accountName ?? 'N/A'}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/deal.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Deal type
                  </Typography>
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {data?.opportunityType ?? 'N/A'} {data?.opportunityType ? ' Deal' : ''}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/calendar-fade.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Close date
                  </Typography>

                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {data?.closeDate ?? 'N/A'}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/stage.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Stage
                  </Typography>
                  <Box sx={{ flex: 1 }}>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Chip
                        label={
                          <Typography
                            variant='responsiveLabel1'
                            color={zeplinColor.Neutral1}
                            sx={{
                              textAlign: 'center',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {data?.stageName ?? 'N/A'}
                          </Typography>
                        }
                        sx={{
                          backgroundColor: zeplinColor.BasicBlack,
                          padding: '5px 12px 5px 12px',
                          borderRadius: '50px',
                          // width: '47px',
                          height: '24px',
                          '&.MuiChip-root': {
                            // flex: 1,
                          },
                          '& .MuiChip-label': {
                            padding: 0,
                          },
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/amount-new.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Amount
                  </Typography>
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      ${data?.amount ?? 'N/A'}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/probability.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Probability
                  </Typography>
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {data?.probability ?? 'N/A'}%
                    </Typography>
                  )}
                </Box>
              </Box>
              {['Marketing', 'Licensing'].includes(data?.opportunityType || '') && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Company Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.companyRevenue ? '$' : ''}
                          {data?.companyRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Client Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.clientRevenue ? '$' : ''}
                          {data?.clientRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Equity
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.gdEquity ? 'True' : 'False'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {['Talent'].includes(data?.opportunityType || '') && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Release Type
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.releaseType ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Rating
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.rating ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {['Talent', 'Development'].includes(data?.opportunityType || '') && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Company Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.companyRevenue ? '$' : ''}
                          {data?.companyRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Client Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.clientRevenue ? '$' : ''}
                          {data?.clientRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/genre.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Genre
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.genre ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/arena.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Arena
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.arena?.replaceAll(';', ', ') ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {['Talent'].includes(data?.opportunityType || '') && (
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/production-status.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Production Status
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.productionStatus ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/type.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Type
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.type ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {data?.opportunityType === 'Fundraising' && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Company Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.companyRevenue ? '$' : ''}
                          {data?.companyRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Client Revenue
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.clientRevenue ? '$' : ''}
                          {data?.clientRevenue ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/type.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Type
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.type ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {!['Fundraising', 'Advertising', 'Talent'].includes(data?.opportunityType || '') && (
                <Box sx={{ display: 'flex', gap: '48px' }}>
                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                    <img
                      src='/assets/amount-new.svg'
                      className={styles['form-icon']}
                      style={{ objectFit: 'fill' }}
                    />
                    <Typography
                      variant='responsiveBody2'
                      color={zeplinColor.Neutral8}
                      sx={{ flex: 1 }}
                    >
                      Estimated valuation
                    </Typography>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                        {data?.estimatedValuation ?? 'N/A'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
              {/* <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img src='/assets/type.svg' width={20} height={20} style={{ objectFit: 'fill' }} />
              <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Type
              </Typography>
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='body2' sx={{ flex: 1 }}>
                  {data?.type ?? 'N/A'}
                </Typography>
              )}
            </Box>
          </Box> */}
            </Box>
          </Box>
          {data?.opportunityType !== 'Fundraising' && (
            <>
              {' '}
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Deal Points</Typography>

                  {data?.opportunityType === 'Marketing' ? (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term start
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termStart
                                ? dayjs(data.termStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term end
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termEnd ? dayjs(data.termEnd).format('DD MMMM, YYYY') : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/exclusivity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivity ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/type.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Type
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.type ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/category.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Category
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.category?.replaceAll(';', ', ') ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/commission.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Commission (%)
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.commission ?? 'N/A'}
                              {data?.commission ? '%' : ''}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  ) : data?.opportunityType === 'Talent' ? (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/role.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Role
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.role ? data?.role?.replaceAll(';', ', ') : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/exclusivity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivity ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term start
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termStart
                                ? dayjs(data.termStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term end
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termEnd ? dayjs(data.termEnd).format('DD MMMM, YYYY') : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Approx. shoot start date
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.approxShootDateStart
                                ? dayjs(data.approxShootDateStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Approx. shoot end date
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.approxShootDateEnd
                                ? dayjs(data.approxShootDateEnd).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/commitments.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Commitments
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.commitments ? data?.commitments : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/episodic.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Episodic order
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.episodicOrder ? data?.episodicOrder : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/commission.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Commission (%)
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.commission ?? 'N/A'}
                              {data?.commission ? '%' : ''}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  ) : data?.opportunityType === 'Development' ? (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/role.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Role
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termStart
                                ? dayjs(data.termStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/exclusivity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivity ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term start
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termStart
                                ? dayjs(data.termStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term end
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termEnd ? dayjs(data.termEnd).format('DD MMMM, YYYY') : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/category.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Category
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.category?.replaceAll(';', ', ') ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/commission.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Commission (%)
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.commission ?? 'N/A'}
                              {data?.commission ? '%' : ''}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  ) : data?.opportunityType === 'Advertising' ? (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/deal-source.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Deal source
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.dealSource ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/exclusivity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivity ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/type.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Type
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.type ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/category.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Category
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.category?.replaceAll(';', ', ') ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  ) : data?.opportunityType === 'Fundraising' ? (
                    <></>
                  ) : (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term start
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termStart
                                ? dayjs(data.termStart).format('DD MMMM, YYYY')
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Term end
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.termEnd ? dayjs(data.termEnd).format('DD MMMM, YYYY') : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/exclusivity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivity ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/type.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Type
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.type ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      {/* <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/partner-percent.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Royal rate
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='body2' sx={{ flex: 1 }}>
                          ${data?.rate ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box> */}
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/category.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Category
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.category?.replaceAll(';', ', ') ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/commission.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Commission (%)
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.commission ?? 'N/A'}
                              {data?.commission ? '%' : ''}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      {data?.opportunityType === 'Licensing' && (
                        <Box sx={{ display: 'flex', gap: '48px' }}>
                          <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                            <img
                              src='/assets/partner-percent.svg'
                              className={styles['form-icon']}
                              style={{ objectFit: 'fill' }}
                            />
                            <Typography
                              variant='responsiveBody2'
                              color={zeplinColor.Neutral8}
                              sx={{ flex: 1 }}
                            >
                              Royalty rate
                            </Typography>
                            {loading ? (
                              <Skeleton
                                variant='text'
                                sx={{
                                  fontSize: theme.typography.body2,
                                  flex: 1,
                                  // Optionally adjust other styles here
                                }}
                              />
                            ) : (
                              <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                                {data?.rate ? '$' : ''}
                                {data?.rate ?? 'N/A'}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            </>
          )}
          {data?.opportunityType !== 'Fundraising' && (
            <>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Services</Typography>
                  {['Marketing', 'Licensing', 'Advertising', 'Talent', 'Development'].includes(
                    data?.opportunityType || '',
                  ) && (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Services
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.services ? stripHtmlTags(data?.services) : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                  {['Talent'].includes(data?.opportunityType || '') && (
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Log line
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.logLine ? stripHtmlTags(data?.logLine) : 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                  {['Development'].includes(data?.opportunityType || '') && (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Executive Producer Services
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.executiveProducerServices ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>{' '}
            </>
          )}
          {!['Fundraising'].includes(data?.opportunityType || '') && (
            <>
              {' '}
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Terms</Typography>
                  {['Marketing', 'Licensing', 'Advertising', 'Talent'].includes(
                    data?.opportunityType || '',
                  ) && (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Compensation
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.compensation ? stripHtmlTags(data?.compensation) : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity Language
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivityLanguage
                                ? stripHtmlTags(data?.exclusivityLanguage)
                                : 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      {!['Marketing'].includes(data?.opportunityType || '') && (
                        <>
                          <Box sx={{ display: 'flex', gap: '48px' }}>
                            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                              <img
                                src='/assets/long-textfield.svg'
                                className={styles['form-icon']}
                                style={{ objectFit: 'fill' }}
                              />
                              <Typography
                                variant='responsiveBody2'
                                color={zeplinColor.Neutral8}
                                sx={{ flex: 1 }}
                              >
                                Options
                              </Typography>
                              {loading ? (
                                <Skeleton
                                  variant='text'
                                  sx={{
                                    fontSize: theme.typography.body2,
                                    flex: 1,
                                    // Optionally adjust other styles here
                                  }}
                                />
                              ) : (
                                <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                                  {data?.options ?? 'N/A'}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: '48px' }}>
                            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                              <img
                                src='/assets/long-textfield.svg'
                                className={styles['form-icon']}
                                style={{ objectFit: 'fill' }}
                              />
                              <Typography
                                variant='responsiveBody2'
                                color={zeplinColor.Neutral8}
                                sx={{ flex: 1 }}
                              >
                                Conditions
                              </Typography>
                              {loading ? (
                                <Skeleton
                                  variant='text'
                                  sx={{
                                    fontSize: theme.typography.body2,
                                    flex: 1,
                                    // Optionally adjust other styles here
                                  }}
                                />
                              ) : (
                                <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                                  {data?.conditions ?? 'N/A'}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </>
                      )}
                    </>
                  )}
                  {['Development'].includes(data?.opportunityType || '') && (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Exclusivity Language
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.exclusivityLanguage ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Options
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.options ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Conditions
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.conditions ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/long-textfield.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Recoupability
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {data?.recoupability ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </>
          )}
          {data?.opportunityType === 'Development' && (
            <>
              {' '}
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Development details</Typography>

                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/calendar-fade.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Approx shoot start date
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.approxShootDateStart
                            ? dayjs(data.approxShootDateStart).format('DD MMMM, YYYY')
                            : 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/calendar-fade.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Approx shoot end date
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.approxShootDateEnd
                            ? dayjs(data.approxShootDateEnd).format('DD MMMM, YYYY')
                            : 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/amount-new.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Production Status
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.productionStatus ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/rating.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Rating
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.rating ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/episodic.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Episodic order
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.episodicOrder ? data?.episodicOrder : 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/release-type.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Release Type
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.releaseType ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/commitments.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Commitments
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.commitments ? data?.commitments : 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </>
          )}
          <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
          <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '20px', xl: '24px' } }}>
              <Typography variant='heading3'>Additional Information</Typography>

              {data?.opportunityType !== 'Fundraising' && (
                <Box sx={{ display: 'flex', gap: '48px' }}>
                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                    <img
                      src='/assets/partner-percent.svg'
                      className={styles['form-icon']}
                      style={{ objectFit: 'fill' }}
                    />
                    <Typography
                      variant='responsiveBody2'
                      color={zeplinColor.Neutral8}
                      sx={{ flex: 1 }}
                    >
                      Partner percent
                    </Typography>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                        {data?.partnerPercent ?? 'N/A'}
                        {data?.partnerPercent ? '%' : ''}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}

              {data?.opportunityType !== 'Fundraising' && (
                <Box sx={{ display: 'flex', gap: '48px' }}>
                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                    <img
                      src='/assets/lead-source.svg'
                      className={styles['form-icon']}
                      style={{ objectFit: 'fill' }}
                    />
                    <Typography
                      variant='responsiveBody2'
                      color={zeplinColor.Neutral8}
                      sx={{ flex: 1 }}
                    >
                      Lead source
                    </Typography>
                    {loading ? (
                      <Skeleton
                        variant='text'
                        sx={{
                          fontSize: theme.typography.body2,
                          flex: 1,
                          // Optionally adjust other styles here
                        }}
                      />
                    ) : (
                      <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                        {data?.leadSource ?? 'N/A'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
              {['Marketing', 'Licensing', 'Advertising', 'Talent'].includes(
                data?.opportunityType || '',
              ) && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/last-modified-by.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Partner Payout
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.Partner_Payout__c ? '$' : ''}
                          {data?.Partner_Payout__c ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {data?.opportunityType === 'Fundraising' && (
                <>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/primary-campaign-source.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Primary Campaign Source
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.campaignName ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/reason-lost.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Reason lost
                  </Typography>
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        flex: 1,
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                      {data?.reasonLost ?? 'N/A'}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          {data?.opportunityType === 'Fundraising' && (
            <>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '20px', xl: '24px' } }}
                >
                  <Typography variant='heading3'>Overview</Typography>
                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/long-textfield.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Overview
                      </Typography>
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.estimatedValuation ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>{' '}
            </>
          )}

          {data?.opportunityType === 'Development' && (
            <>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Log line</Typography>
                  <>
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Log line
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.logLine ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </>
                </Box>
              </Box>{' '}
            </>
          )}

          {data?.opportunityType === 'Development' && (
            <>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Fees</Typography>
                  <>
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Guarantee
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.Guarantee__c ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          MAGR
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.magr ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Conditions
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.conditions ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '48px' }}>
                      <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                        <img
                          src='/assets/long-textfield.svg'
                          className={styles['form-icon']}
                          style={{ objectFit: 'fill' }}
                        />
                        <Typography
                          variant='responsiveBody2'
                          color={zeplinColor.Neutral8}
                          sx={{ flex: 1 }}
                        >
                          Executive Producer Fees
                        </Typography>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                            {data?.executiveProducerFee ?? 'N/A'}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </>
                </Box>
              </Box>{' '}
            </>
          )}
          <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
          <Box sx={{ padding: { xs: '20px', sm: '24px' } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', sm: '24px' } }}>
              <Typography variant='responsiveHeading3'>System Information</Typography>

              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/opportunity-owner.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Opportunity owner
                  </Typography>
                </Box>
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      flex: 1,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Box sx={{ display: 'flex', gap: '4px', flex: 1, alignItems: 'center' }}>
                    <Box
                      sx={{
                        borderRadius: '100px',
                        padding: '10px',
                        width: '26px',
                        height: '26px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: zeplinColor.Blue3,
                      }}
                    >
                      <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                        {data?.ownerName
                          ?.split(' ')
                          .map((value: any, index: number) =>
                            data?.ownerName &&
                            (index === 0 || index === data?.ownerName?.split(' ').length - 1)
                              ? value[0]
                              : '',
                          )}
                      </Typography>
                    </Box>
                    <Typography variant='responsiveBody2'>{data?.ownerName ?? 'N/A'}</Typography>
                  </Box>
                )}
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/calendar-fade.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Created date
                  </Typography>
                </Box>

                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      flex: 1,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                    {data?.createdDate?.split('T')[0] ?? 'N/A'}
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: 'flex', gap: '48px' }}>
                <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <img
                    src='/assets/last-modified-by.svg'
                    className={styles['form-icon']}
                    style={{ objectFit: 'fill' }}
                  />
                  <Typography
                    variant='responsiveBody2'
                    color={zeplinColor.Neutral8}
                    sx={{ flex: 1 }}
                  >
                    Last modified by
                  </Typography>
                </Box>
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      flex: 1,
                      // Optionally adjust other styles here
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                    {data?.lastModifiedByName ?? 'N/A'}
                  </Typography>
                )}
              </Box>
              {/* <Box sx={{ display: 'flex', gap: '48px' }}>
            <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
              Created by
            </Typography>

            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  flex: 1,
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Box sx={{ display: 'flex', gap: '4px', flex: 1, alignItems: 'center' }}>
                <Box
                  sx={{
                    borderRadius: '100px',
                    padding: '10px',
                    width: '26px',
                    height: '26px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: zeplinColor.Blue3,
                  }}
                >
                  <Typography variant='label1' color={zeplinColor.Neutral1}>
                    {data?.createdByName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        data?.createdByName &&
                        (index === 0 || index === data?.createdByName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                </Box>
                <Typography variant='body2'>{data?.createdByName ?? 'N/A'}</Typography>
              </Box>
            )}
          </Box> */}
            </Box>
          </Box>
        </>
      ) : (
        <>
          {data?.products && data?.products?.length > 0 ? (
            <>
              <Box sx={{ padding: { xs: '0px 20px 20px 20px', xl: '0px 24px 24px 24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', sm: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>Price Book</Typography>

                  <Box sx={{ display: 'flex', gap: '48px' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/price-book.svg'
                        className={styles['form-icon']}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography
                        variant='responsiveBody2'
                        color={zeplinColor.Neutral8}
                        sx={{ flex: 1 }}
                      >
                        Price book
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                          {data?.products[0]?.pricebook2Name ?? 'N/A'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box sx={{ padding: { xs: '20px 20px 24px 20px', xl: '24px 24px 24px 24px' } }}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '14px', xl: '24px' } }}
                >
                  <Typography variant='responsiveHeading3'>
                    Products ({data?.products?.length})
                  </Typography>
                  {data?.products?.map((val: any) => (
                    <>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/product-name.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Product name
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {val?.ProductName ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/deal.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Product family
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {val?.ProductFamily ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/amount-new.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Sales price
                          </Typography>

                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {val?.SalesPrice ? '$' : ''}
                              {val?.SalesPrice ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/quantity.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Quantity
                          </Typography>
                          <Box sx={{ flex: 1 }}>
                            {loading ? (
                              <Skeleton
                                variant='text'
                                sx={{
                                  fontSize: theme.typography.body2,
                                  flex: 1,
                                  // Optionally adjust other styles here
                                }}
                              />
                            ) : (
                              <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                                {val?.Quantity ?? 'N/A'}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/calendar-fade.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            Date
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {val?.Date ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', gap: '48px' }}>
                        <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                          <img
                            src='/assets/amount-new.svg'
                            className={styles['form-icon']}
                            style={{ objectFit: 'fill' }}
                          />
                          <Typography
                            variant='responsiveBody2'
                            color={zeplinColor.Neutral8}
                            sx={{ flex: 1 }}
                          >
                            List price
                          </Typography>
                          {loading ? (
                            <Skeleton
                              variant='text'
                              sx={{
                                fontSize: theme.typography.body2,
                                flex: 1,
                                // Optionally adjust other styles here
                              }}
                            />
                          ) : (
                            <Typography variant='responsiveBody2' sx={{ flex: 1 }}>
                              {val?.ListPrice ? '$' : ''}
                              {val?.ListPrice ?? 'N/A'}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
                    </>
                  ))}
                </Box>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                position: 'absolute',
                top: { xs: '10rem', xl: '15rem' },
                left: 0,
                right: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: { xs: '16px', xl: '32px' },
              }}
            >
              <img src={`/assets/no-pricebook.svg`} className={styles['no-pricebook-icon']} />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: { xs: '6px', xl: '12px' },
                  textAlign: 'center',
                }}
              >
                <Typography variant='responsiveHeading3'>No Products Added Yet</Typography>
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                  {' '}
                  Start by selecting a price book to add products
                  <br /> and set pricing for this deal
                </Typography>
              </Box>
              <CustomButton
                disabled={false}
                onClick={(e: any) => {
                  handleDealCreateClick(e);
                  sessionStorage.setItem('selectedDeal', JSON.stringify(data));
                  sessionStorage.setItem('activeDealTab', '1');
                }}
                variant='contained'
                buttonVariant='responsiveButtonLarge'
                color={'primary'}
                style={{
                  // width: '100%',

                  borderRadius: { xs: '10px', xl: '14px' },
                  height: { xs: 30, xl: 48 },
                  padding: { xs: '10px 12px', xl: '14px 16px' },
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Add Price Book'}
                icon={<img src={`/assets/add-white.svg`} className={styles['add-icon']} />}
                // tabindex={4}
              />
            </Box>
          )}
        </>
      )}
    </CustomCard>
  );
};

export default KeyDealsDetail;
